import axios from "axios";
import { apiVariable } from "./apiVariable";
import {
  AssignEmployeePtoSubPolicyDto,
  CreatePtoAccrualSubPolicyDto,
  EmployeePtoSubPolicyAssignmentDto,
  PtoAccrualSubPolicyDto,
} from "../interfaces/HR/ptoAccrualSubPolicy";

const authorization = (token: string) => ({
  headers: { Authorization: `Bearer ${token}` },
});

export const getPtoAccrualSubPolicies = async (token: string) => {
  const { data } = await axios.get<PtoAccrualSubPolicyDto[]>(
    `${apiVariable}/pto-sub-policies`,
    authorization(token),
  );
  return data;
};

export const createPtoAccrualSubPolicy = async (
  token: string,
  dto: CreatePtoAccrualSubPolicyDto,
) => {
  const { data } = await axios.post<PtoAccrualSubPolicyDto>(
    `${apiVariable}/pto-sub-policies`,
    dto,
    authorization(token),
  );
  return data;
};

export const getEmployeePtoSubPolicyAssignments = async (
  token: string,
  employeeId: string,
) => {
  const { data } = await axios.get<EmployeePtoSubPolicyAssignmentDto[]>(
    `${apiVariable}/pto-sub-policies/employees/${employeeId}/assignments`,
    authorization(token),
  );
  return data;
};

export const assignEmployeePtoSubPolicy = async (
  token: string,
  employeeId: string,
  dto: AssignEmployeePtoSubPolicyDto,
) => {
  const { data } = await axios.post<EmployeePtoSubPolicyAssignmentDto>(
    `${apiVariable}/pto-sub-policies/employees/${employeeId}/assignments`,
    dto,
    authorization(token),
  );
  return data;
};
